export const questions = [
  {
    id: "q1",
    category: "web-fundamentals",
    difficulty: "beginner",
    prompt: "What is the primary role of HTML in a web application?",
    options: [
      {
        id: "structure",
        text: "Define the structure and meaning of the page content",
      },
      {
        id: "styling",
        text: "Control all visual styles and animations",
      },
      {
        id: "database",
        text: "Store application data permanently",
      },
      {
        id: "server",
        text: "Run the application's backend server",
      },
    ],
    correctOptionId: "structure",
    explanation:
      "HTML defines the structure and semantic meaning of web content. CSS controls presentation, while JavaScript adds behavior and interactivity.",
  },

  {
    id: "q2",
    category: "web-fundamentals",
    difficulty: "beginner",
    prompt: "What is JavaScript commonly used for in a web application?",
    options: [

      {
        id: "markup",
        text: "Defining the semantic structure of the page",
      },
      {
        id: "image-editing",
        text: "Editing image files before they are uploaded",
      },
      {
        id: "operating-system",
        text: "Managing the user's operating system",
      },
      {
        id: "interactivity",
        text: "Adding behavior and interactivity to the application",
      },
    ],
    correctOptionId: "interactivity",
    explanation:
      "JavaScript handles behavior such as responding to clicks, validating forms, updating page content, and communicating with APIs.",
  },

  {
    id: "q3",
    category: "react-state",
    difficulty: "beginner",
    prompt:
      "In a React quiz component, where should the student's selected answers normally be stored?",
    options: [
      {
        id: "css",
        text: "Inside a CSS class",
      },
      {
        id: "heading",
        text: "Inside the page heading",
      },
      {
        id: "filename",
        text: "In the component's filename",
      },
      {
        id: "state",
        text: "In component or application state",
      },      
    ],
    correctOptionId: "state",
    explanation:
      "React state stores information that can change while the user interacts with the application. Selected answers can be stored by question ID and updated whenever the student changes an answer.",
  },

  {
    id: "q4",
    category: "testing-debugging",
    difficulty: "beginner",
    prompt:
      "An AI assistant generates code that increases the score every time a correct option is clicked. What is the best correction?",
    options: [
      {
        id: "disable-clicks",
        text: "Allow the student to click each answer only once",
      },
      {
        id: "increase-total",
        text: "Increase the total number of questions after every click",
      },
      {
        id: "hide-score",
        text: "Hide the score so the user cannot see the problem",
      },
      {
        id: "calculate-submit",
        text: "Store each selected answer and calculate the score during submission",
      },      
    ],
    correctOptionId: "calculate-submit",
    explanation:
      "The application should store one current answer per question. It should compare those answers with the answer key during submission instead of incrementing the score on every click.",
  },

  {
    id: "q5",
    category: "responsible-ai",
    difficulty: "beginner",
    prompt:
      "What should you do before using code generated by an AI coding assistant?",
    options: [
      {
        id: "deploy-immediately",
        text: "Deploy it immediately because AI-generated code is already tested",
      },
      {
        id: "remove-errors",
        text: "Delete all error messages without investigating them",
      },
      {
        id: "review-test",
        text: "Read, understand, and test the generated code",
      },      
      {
        id: "trust-length",
        text: "Trust the code if the response is detailed",
      },
    ],
    correctOptionId: "review-test",
    explanation:
      "AI-generated code can contain logical errors, insecure patterns, outdated APIs, or incorrect assumptions. The developer remains responsible for reviewing and testing it.",
  },

  {
    id: "q6",
    category: "responsible-ai",
    difficulty: "beginner",
    prompt:
      "An AI assistant places a private API key inside a React component. What should you do?",
    options: [
      {
        id: "rename-key",
        text: "Rename the variable so users cannot recognize it",
      },
      {
        id: "hide-css",
        text: "Hide the key using CSS",
      },
      {
        id: "commit-key",
        text: "Commit the key because the repository is needed for deployment",
      },
      {
        id: "move-server",
        text: "Move the key to a protected server-side environment variable",
      },
    ],
    correctOptionId: "move-server",
    explanation:
      "Frontend code is sent to the user's browser and can be inspected. Private API keys must remain on the server and should not be committed to the repository.",
  },

  {
    id: "q7",
    category: "testing-debugging",
    difficulty: "beginner",
    prompt:
      "Which test is most important for checking the scoring logic of a quiz application?",
    options: [
      {
        id: "logo-size",
        text: "Verify that the logo file is large",
      },
      {
        id: "change-answer",
        text: "Verify that changing an answer does not add an extra point",
      },      
      {
        id: "button-color",
        text: "Verify that every button uses the same color",
      },
      {
        id: "long-name",
        text: "Verify that the component has a long filename",
      },
    ],
    correctOptionId: "change-answer",
    explanation:
      "Changing an answer tests whether the application stores one current selection per question. The score should be based on the final selections, not the number of clicks.",
  },

  {
    id: "q8",
    category: "responsible-ai",
    difficulty: "beginner",
    prompt:
      "Why should a developer create small, descriptive Git commits while building an application?",
    options: [
      {
        id: "track-changes",
        text: "To make changes easier to understand, review, and reverse",
      },
      {
        id: "hide-code",
        text: "To prevent other developers from reading the code",
      },
      {
        id: "replace-tests",
        text: "To remove the need for automated tests",
      },
      {
        id: "deploy-secret",
        text: "To store secret API keys safely",
      },
    ],
    correctOptionId: "track-changes",
    explanation:
      "Small commits with clear messages document how the project developed. They make code review, debugging, collaboration, and reversing problematic changes easier.",
  },

  {
    id: "q9",
    category: "responsible-ai",
    difficulty: "beginner",
    prompt:
      "How should a text label be connected to a radio input in an accessible quiz?",
    options: [
      {
        id: "same-color",
        text: "Give the label and input the same color",
      },
      {
        id: "placeholder",
        text: "Replace the label with a placeholder",
      },
      {
        id: "image",
        text: "Convert the label text into an image",
      },
      {
        id: "label-connection",
        text: "Use a label whose htmlFor value matches the input's id",
      },      
    ],
    correctOptionId: "label-connection",
    explanation:
      "Connecting a label to its input helps screen-reader and keyboard users understand and select the answer. In React, the label uses htmlFor and the input uses the corresponding id.",
  },

  {
    id: "q10",
    category: "responsible-ai",
    difficulty: "beginner",
    prompt:
      "What should an application do if its AI explanation service is unavailable?",
    options: [
      {
        id: "fallback",
        text: "Show a clear error and provide the stored non-AI explanation",
      },
      {
        id: "change-score",
        text: "Change the student's score to zero",
      },
      {
        id: "fake-response",
        text: "Display a fabricated AI response",
      },
      {
        id: "delete-attempt",
        text: "Delete the student's quiz attempt",
      },
    ],
    correctOptionId: "fallback",
    explanation:
      "The core quiz should continue working without AI. A stored explanation gives the student useful feedback while the application clearly communicates that personalized AI help is temporarily unavailable.",
  },
  {
    id: "q11",
    category: "react-state",
    difficulty: "beginner",
    prompt:
      "In a controlled React input, what should the onChange handler usually do?",
    options: [
      {
        id: "update-state",
        text: "Update the state value using the user's latest input",
      },
      {
        id: "reload-page",
        text: "Reload the page after every change",
      },
      {
        id: "modify-dom",
        text: "Modify the DOM element directly without updating state",
      },
      {
        id: "css-variable",
        text: "Store the input only in a global CSS variable",
      },
    ],
    correctOptionId: "update-state",
    explanation:
      "A controlled input receives its value from React state, so its onChange handler updates that state with the user's latest input.",
  },
];

export const quiz = {
  id: "ai-web-development-fundamentals",
  title: "Building Web Applications Safely with AI",
  description:
    "Test your understanding of web fundamentals, AI-generated code, debugging, testing, security, Git, and accessibility.",
  targetAudience:
    "Beginner web developers using AI coding assistants",
  difficulty: "Beginner",
  estimatedMinutes: 8,
  passingPercentage: 70,
  questions,
};